'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var triggerCustomEvent = require('trigger-custom-event');

var appDom = require('./app-dom');

var data;

var trackEvent = function(event) {

	$.ajax({
		url: '?promotions=promotion.track',
		method: 'POST',
		dataType: 'json',
		data: {
			promotionId: data.id,
			event: event
		}
	}).done(function() {

		triggerCustomEvent('promo-' + event + '-tracked', {
			target: appDom.promo
		});

	});

};

var onPromoOpened = function() {

	trackEvent('view');

};

var onPromoClosed = function() {

	trackEvent('close');

};

var onPromoClicked = function() {

	trackEvent('click');

};

var onPromoFormSubmission = function() {

	trackEvent('form_submission');

};

var init = function(d) {

	data = d;

	appDom.promo
		.on({
			'promo-opened': onPromoOpened,
			'promo-closed': onPromoClosed,
			'promo-form-submission-success': onPromoFormSubmission
		})
		.on('promo-custom-link-clicked', onPromoClicked);

};

module.exports = {
	init: init
};
